import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=9d16e7f8&scoped=true&"
import script from "./ChatComponent.vue?vue&type=script&lang=js&"
export * from "./ChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=9d16e7f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d16e7f8",
  null
  
)

export default component.exports